<template>
  <t-form labelWidth="110px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <e-collapse title="标题" :expand="true">
      <t-form-item label="标题文本">
        <t-input v-model="attribute.title.text" size="small" :maxcharacter="52" />
      </t-form-item>
      <t-form-item label="标题大小">
        <t-input-number v-model="attribute.title.textStyle.fontSize" size="small" :min="2" :max="100"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="标题颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.textStyle.color"
          size="small" />
      </t-form-item>
      <t-form-item label="标题位置(X)">
        <e-chart-position v-model="attribute.title.left" :direction="'x'" />
      </t-form-item>
      <t-form-item label="标题位置(Y)">
        <e-chart-position v-model="attribute.title.top" :direction="'y'" />
      </t-form-item>
    </e-collapse>
    <e-collapse title="图例" :expand="false">
      <t-form-item label="图例显示">
        <t-switch v-model="attribute.legend.show" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="图例位置(X)">
        <e-chart-position v-model="attribute.legend.left" :direction="'x'" />
      </t-form-item>
      <t-form-item label="图例位置(Y)">
        <e-chart-position v-model="attribute.legend.top" :direction="'y'" />
      </t-form-item>
      <t-form-item label="图例布局方式">
        <t-radio-group v-model="attribute.legend.orient" size="small">
          <t-radio-button value="vertical">纵向</t-radio-button>
          <t-radio-button value="horizontal">横向</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="图例字体">
        <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="字体">
        <t-select v-model="attribute.legend.textStyle.fontFamily" size="small">
          <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="图例文字颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small"
          v-model="attribute.legend.textStyle.color" />
      </t-form-item>
    </e-collapse>
    <e-collapse title="内边距" :expand="false">
      <t-form-item label="内边距(左)">
        <t-input-number size="small" v-model="attribute.grid.x" :min="0" :max="200" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="内边距(上)">
        <t-input-number size="small" v-model="attribute.grid.y" :min="0" :max="200" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="内边距(右)">
        <t-input-number size="small" v-model="attribute.grid.x2" :min="0" :max="200" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="内边距(下)">
        <t-input-number size="small" v-model="attribute.grid.y2" :min="0" :max="200" :decimal-places="0" />
      </t-form-item>
    </e-collapse>
    <e-collapse title="x轴" :expand="false">
      <t-form-item label="x轴">
        <t-switch v-model="attribute.xAxis.show" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="指示文字">
        <t-input v-model="attribute.xAxis.name" size="small" :maxcharacter="40" />
      </t-form-item>
      <t-form-item label="轴线显示">
        <t-switch v-model="attribute.xAxis.axisLine.show" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="轴线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLine.lineStyle.color"
          size="small" />
      </t-form-item>
      <t-form-item label="刻度线">
        <t-switch v-model="attribute.xAxis.axisTick.show" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLabel.color"
          size="small" />
      </t-form-item>
      <t-form-item label="字体">
        <t-select v-model="attribute.xAxis.axisLabel.fontFamily" size="small">
          <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="字号">
        <t-input-number v-model="attribute.xAxis.axisLabel.fontSize" :min="1" :max="100" size="small"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="字体倾斜">
        <t-input-number v-model="attribute.xAxis.axisLabel.rotate" :min="-180" :max="180" size="small"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="网格线">
        <t-switch v-model="attribute.xAxis.splitLine.show" :label="['开', '关']" size="small" />
      </t-form-item>
    </e-collapse>
    <e-collapse title="y轴" :expand="false">
      <t-form-item label="隐藏">
        <t-checkbox-group class="yaxis-show" v-modal="attribute.yAxis.yAxisShows" @change="onchangeyAxisShows">
          <t-checkbox v-for="name in yAxisShow" :key="name" :label="name" :value="name" />
        </t-checkbox-group>
      </t-form-item>

      <t-form-item label="字号">
        <t-input-number v-model="attribute.yAxis.axisLabel.fontSize" :min="1" :max="100" size="small"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="字体">
        <t-select v-model="attribute.yAxis.axisLabel.fontFamily" size="small">
          <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="字体倾斜">
        <t-input-number v-model="attribute.yAxis.axisLabel.rotate" :min="-180" :max="180" size="small"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="字体色">
        <div class="yAxisColor-wrap">
          <div v-for="(name, index) in yAxisShow" :key="name" class="y-textColor-item">
            <span>{{ name }}</span>
            <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLabel.yColors[index]"
              size="small" />
          </div>

        </div>

      </t-form-item>

      <t-form-item label="网格线">
        <t-switch v-model="attribute.yAxis.splitLine.show" :label="['开', '关']" size="small" />
      </t-form-item>
    </e-collapse>
    <e-collapse title="数值" :expand="true">
      <t-form-item label="数值显示">
        <t-switch v-model="attribute.series.label.show" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="数值字体">
        <t-input-number v-model="attribute.series.label.fontSize" :min="2" :max="100" size="small"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="数值颜色" v-show="attribute.series.label.color">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.series.label.color" size="small" />
      </t-form-item>
      <t-form-item label="数值位置" v-show="attribute.series.label.position">
        <t-select v-model="attribute.series.label.position" size="small">
          <t-option label="顶部" value="top" />
          <t-option label="左" value="left" />
          <t-option label="右" value="right" />
          <t-option label="底部" value="bottom" />
          <t-option label="中心" value="inside" />
        </t-select>
      </t-form-item>
      <t-form-item>
        <template slot="label">
          数值单位
          <t-tooltip content="双Y轴/多Y轴折线柱状图的数值单位需要在数据中包含unit字段" :overlay-style="{ width: '200px' }" placement="top-right"
            show-arrow>
            <t-icon name="info-circle" />
          </t-tooltip>
        </template>
        <t-switch v-model="attribute.series.label.unit" :label="['开', '关']" size="small" />
      </t-form-item>
    </e-collapse>
    <e-collapse title="柱体" :expand="true">
      <t-form-item label="柱体背景">
        <t-switch v-model="attribute.series.showBackground" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="柱体宽度">
        <t-input-number v-model="attribute.series.barWidth" :min="1" :max="100" size="small" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="平滑曲线">
        <t-switch v-model="attribute.series.smooth" :label="['开', '关']" size="small" />
      </t-form-item>
    </e-collapse>
    <t-form-item label="配色">
      <e-color-group v-model="attribute.color" :max="20" :gradient="true" />
    </t-form-item>
    <t-form-item label="X轴拖动" v-if="attribute.dataZoom">
      <t-switch v-model="attribute.dataZoom.show" />
    </t-form-item>
    <t-form-item label="X轴拖动高度" v-if="attribute.dataZoom && attribute.dataZoom.show">
      <t-input-number v-model="attribute.dataZoom.height" :min="0" :max="50" size="small" :decimal-places="0" />
    </t-form-item>
  </t-form>
</template>

<script>
import EChartPosition from "@/components/designer/e-chart-position";
import EColorGroup from "@/components/designer/e-color-group";
import CptData from '@/components/element/options/comp/cpt-data'
import { useEchartStore } from '@/stores/echartStore'
import { mapState } from 'pinia'
export default {
  name: "cpt-chart-line-multiple-option",
  components: { EColorGroup, EChartPosition, CptData },
  props: { attribute: Object, cptDataForm: Object, currentCpt: Object, refMap: Object },
  data() {
    return {
      textFamilyList: [],
    }
  },
  computed: {
    ...mapState(useEchartStore, {
      yAxisShow: function (store) {
        let id = this.currentCpt.id || ''
        // console.log(this.options[this.currentCpt.id],'qwdio0jqd0jqwjdqd0qd0ij');
        let list = store.options[id]?.yAxis.map(item => item.name)
        return list
      }
    }),
    // yAxisShow: function () {
    //   let id = this.currentCpt.id || ''
    //   console.log(this, 'qwdio90qwj0idwqji0dwqid');
    //   // console.log(this.options[this.currentCpt.id],'qwdio0jqd0jqwjdqd0qd0ij');
    //   return this.options[id].map(item => item.name)
    // }
  },
  created() {
    this.textFamilyList = require('@/assets/font/font-list')
    if (!this.attribute.yAxis.axisLabel?.yColors) {
      this.attribute.yAxis.axisLabel.yColors = []
    }
  },
  methods: {
    onchangeyAxisShows(value) {
      console.log(value, 'qwdijqwidqid');
      this.attribute.yAxis.yAxisShows = value
    }
  }


}
</script>

<style scoped>
.colorBlock {
  float: left;
  width: 25px;
  height: 25px;
  margin-right: 2px;
}

.colorBlock:hover .delTag {
  display: inline-block
}

.delTag {
  width: 100%;
  height: 100%;
  display: none;
  text-align: center;
  font-size: 18px;
  color: #fff
}

.yaxis-show {
  display: flex;
  flex-direction: column;
}

.yAxisColor-wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.yAxisColor-wrap .y-textColor-item {
  display: flex;
  flex-direction: column;
  border: 1px solid #4d4d4d;
  border-bottom: unset;
  padding: 5px 10px;
}

.yAxisColor-wrap .y-textColor-item:last-of-type {
  border-bottom: 1px solid #4d4d4d;
}

.yAxisColor-wrap .y-textColor-item span {
  padding-bottom: 5px;
  display: inline-block;
}
</style>
